export interface ApeConfig {
  level0Prompt: string;
  level6Prompt: string;
  generationPromptTemplate: string;
  level0Enabled: boolean;
  level6Enabled: boolean;
}

const EMPTY_APE_CONFIG: ApeConfig = {
  level0Prompt: '',
  level6Prompt: '',
  generationPromptTemplate: '',
  level0Enabled: false,
  level6Enabled: false,
};

export async function getApeConfig(): Promise<ApeConfig> {
  try {
    const response = await fetch('/api/ape-config', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error(`Errore ${response.status}`);
    }
    const payload = await response.json() as {
      success?: boolean;
      config?: Partial<ApeConfig>;
      level0Prompt?: string;
      level6Prompt?: string;
      generationPromptTemplate?: string;
      level0Enabled?: boolean;
      level6Enabled?: boolean;
    };
    const config = payload?.config || payload;
    const level0Prompt = String(config?.level0Prompt || '').trim();
    const level6Prompt = String(config?.level6Prompt || '').trim();
    const generationPromptTemplate = String(config?.generationPromptTemplate || '').trim();
    return {
      level0Prompt,
      level6Prompt,
      generationPromptTemplate,
      level0Enabled: Boolean(config?.level0Enabled || level0Prompt),
      level6Enabled: Boolean(config?.level6Enabled || level6Prompt),
    };
  } catch (error) {
    console.warn('[apeConfigService] fallback config:', error);
    return EMPTY_APE_CONFIG;
  }
}
